/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const IncidentTimelineType = {
  ThresholdBreached: 'THRESHOLD_BREACHED',
  IncidentAcknowledged: 'INCIDENT_ACKNOWLEDGED',
  IncidentResolved: 'INCIDENT_RESOLVED',
  IncidentActionCompleted: 'INCIDENT_ACTION_COMPLETED',
  IncidentActionSkipped: 'INCIDENT_ACTION_SKIPPED',
} as const

export type IncidentTimelineType =
  (typeof IncidentTimelineType)[keyof typeof IncidentTimelineType]
